// extracted by mini-css-extract-plugin
module.exports = {"heading":"Header_heading__sAf1D"};